const React = require("react");
const {object, string} = require("yup");
const trim = require("mn-utils/trim");

const {replaceLocation} = require("../../../router");
const {LINK_DASHBOARD} = require("../../../constants/links");
const {FormWrapper, FormSubmitBtn} = require("../../dumb/FormHandlers");
const Base = require("../../smart/Page/AuthLayout");
const {AuthInputPassword} = require("../../dumb/FormInputs");
const {decorateReconnect, apiAuthUpdatePwd} = require("../../../api/_auth");
const {onAccount} = require("../../../emitters/account");

const updatePwd = decorateReconnect(apiAuthUpdatePwd);

module.exports = (props) => {
  const trimHandler = [trim];

  const schema = object({
    old_pass: string()
      .isValidOldPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required(),
    new_pass: string()
      .isValidNewPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required(),
    repeat_pass: string()
      .test(
        'passRepeatCheck',
        'Password must be the same as a new one',
        (val, ctx) => {
          return val === ctx.parent.new_pass;
        }
      )
      .required()
  });

  const onSubmit = (data) => (
    updatePwd({
      old_password: data.old_pass,
      password: data.new_pass,
    }).then(onAccount)
  );

  const onResult = () => {
    replaceLocation({
      path: LINK_DASHBOARD,
    })
  };

  const resultModalData = ['Your password has been changed!'];

  return (
    <FormWrapper
      data={{token: (props.params || {}).token}}
      schema={schema}
      onSubmit={onSubmit}
      onResult={onResult}
      resultModalData={resultModalData}
    >
      {(formCtx) => (
        <Base
          title="Setup new password"
          content={(
            <>
              <div className="mt-35 mb30">
                <AuthInputPassword
                  label="Old Password"
                  name="old_pass"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
              </div>
              <div className="mb30">
                <AuthInputPassword
                  label="New Password"
                  name="new_pass"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
              </div>
              <div>
                <AuthInputPassword
                  label="Repeat Password"
                  name="repeat_pass"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
              </div>
            </>
          )}
          control={(
            <FormSubmitBtn formCtx={formCtx}>
              Reset password
            </FormSubmitBtn>
          )}
        />
      )}
    </FormWrapper>
  )
}
